window.theme = window.theme || {};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();
window.theme = window.theme || {};

theme.Product = (function() {
  function Product(container) {  
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      errorQuantityMessage: '#error-quantity-' + sectionId,
      quantity: '#Quantity-' + sectionId,
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productImageWraps: '.product-single__photo',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productThumbListItem: '.product-single__thumbnails-item',
      productFeaturedImage: '.product-featured-img',
      productThumbsWrapper: '.thumbnails-wrapper',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]'
    };

    this.classes = {
      hidden: 'hide',
      productOnSale: 'price--on-sale',
      productUnavailable: 'price--unavailable',
      activeClass: 'active-thumb'
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    );

    //this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    //this._initImageSwitch();
    this._initAddToCart();
    //this._setActiveThumbnail();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages)
        .on('click', function(evt) {
          evt.preventDefault();
          var $el = $(this);

          var imageId = $el.data('thumbnail-id');

          self._switchImage(imageId);
          self._setActiveThumbnail(imageId);
        })
        .on('keyup', self._handleImageFocus.bind(self));
    },

    _initAddToCart: function() {
      var self = this;
      var $quantityInput = $(self.selectors.quantity);

      if ($quantityInput.length === 0) return;

      $(self.selectors.addToCart).on('click', function(evt) {
        var isInvalidQuantity = $quantityInput.val() <= 0;

        $(self.selectors.errorQuantityMessage).toggleClass(
          self.classes.hidden,
          !isInvalidQuantity
        );

        if (isInvalidQuantity) {
          $quantityInput
            .attr(
              'aria-describedby',
              'error-quantity-' + self.settings.sectionId
            )
            .attr('aria-invalid', true);
          $(self.selectors.errorQuantityMessage).focus();
          evt.preventDefault();
        } else {
          $quantityInput
            .removeAttr('aria-describedby')
            .removeAttr('aria-invalid');
        }
      });
    },

    _setActiveThumbnail: function(imageId) {
      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(this.selectors.productImageWraps + ":not('.hide')").data(
          'image-id'
        );
      }

      var $thumbnailWrappers = $(
        this.selectors.productThumbListItem + ':not(.slick-cloned)'
      );

      var $activeThumbnail = $thumbnailWrappers.find(
        this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          imageId +
          "']"
      );

      $(this.selectors.productThumbImages)
        .removeClass(this.classes.activeClass)
        .removeAttr('aria-current');

      $activeThumbnail.addClass(this.classes.activeClass);
      $activeThumbnail.attr('aria-current', true);

      if (!$thumbnailWrappers.hasClass('slick-slide')) {
        return;
      }

      var slideIndex = $activeThumbnail.parent().data('slick-index');
      $(this.selectors.productThumbs).slick('slickGoTo', slideIndex, true);
    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );

      $newImage.removeClass(this.classes.hidden);
      $otherImages.addClass(this.classes.hidden);
    },

    _handleImageFocus: function(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      $(this.selectors.productFeaturedImage + ':visible').focus();
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-list')
        .removeAttr('aria-live');
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-disabled')
        .removeAttr('aria-disabled');

      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('[tabindex="-1"]')
        .removeAttr('tabindex');
    },

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]';

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.textContent = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
          $(this.selectors.shopifyPaymentButton, this.$container).show();
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
      }
    },

    _updateAvailability: function(evt) {
      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
      
      // Trigger custom event for restock notifications
      //console.log('_updateAvailability');
      this.$container.trigger({type: 'availabilityUpdated'});
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);

      // Reset product price state
      $priceContainer
        .removeClass(this.classes.productUnavailable)
        .removeClass(this.classes.productOnSale)
        .removeAttr('aria-hidden');

      // Unavailable
      if (!variant) {
        $priceContainer
          .addClass(this.classes.productUnavailable)
          .attr('aria-hidden', true);
        return;
      }

      // On sale
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $salePrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $priceContainer.addClass(this.classes.productOnSale);
      } else {
        // Regular price
        $regularPrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {  
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});
window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace
        ? 'focusout.' + options.namespace
        : 'focusout',
      keydown: options.namespace
        ? 'keydown.' + options.namespace
        : 'keydown.handleFocus'
    };

    /**
     * Get every possible visible focusable element
     */
    var $focusableElements = options.$container.find(
      $(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      ).filter(':visible')
    );
    var firstFocusable = $focusableElements[0];
    var lastFocusable = $focusableElements[$focusableElements.length - 1];

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    function _manageFocus(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

      /**
       * On the last focusable element and tab forward,
       * focus the first element.
       */
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault();
        firstFocusable.focus();
      }
      /**
       * On the first focusable element and tab backward,
       * focus the last element.
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventsName.focusout, function() {
      $(document).off(eventsName.keydown);
    });

    $(document).on(eventsName.focusin, function(evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      $(document).on(eventsName.keydown, function(evt) {
        _manageFocus(evt);
      });
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
  accessibleLinks: function(options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message'
    };

    if (options.$links === undefined || !options.$links.jquery) {
      options.$links = $('a[href]:not([aria-describedby])');
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = $.extend(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.'
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite($link) {
      var hostname = window.location.hostname;

      return $link[0].hostname !== hostname;
    }

    $.each(options.$links, function() {
      var $link = $(this);
      var target = $link.attr('target');
      var rel = $link.attr('rel');
      var isExternal = _externalSite($link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        $link.attr('aria-describedby', idSelectors.external);
      }
      if (isTargetBlank) {
        if (rel === undefined || rel.indexOf('noopener') === -1) {
          $link.attr('rel', 'noopener');
        }
        $link.attr('aria-describedby', idSelectors.newWindow);
      }
      if (isExternal && isTargetBlank) {
        $link.attr('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  }
};
window.slate = window.slate || {};

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {      
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();
window.kkco = window.kkco || {};

kkco.Customer = (function($) {

	function initCustomer() {
		checkUrlHash();
		customerAddressForm();
		initEventListeners();
		resetPasswordSuccess();
	}

	function initEventListeners() {
		// Show reset password form
		$('#RecoverPassword').on('click', function(evt) {
			evt.preventDefault();
			toggleRecoverPasswordForm();
		});

		// Hide reset password form
		$('#HideRecoverPasswordLink').on('click', function(evt) {
			evt.preventDefault();
			toggleRecoverPasswordForm();
		});
	}

	/**
	*
	*  Show/Hide recover password form
	*
	*/
	function toggleRecoverPasswordForm() {
		$('#RecoverPasswordForm').toggleClass('hide');
		$('#CustomerLoginForm').toggleClass('hide');
	}

	/**
	*
	*  Show reset password success message
	*
	*/
	function resetPasswordSuccess() {
		var $formState = $('.reset-password-success');

		// check if reset password form was successfully submited.
		if ( ! $formState.length) {
			return;
		}

		// show success message
		$('#ResetSuccess').removeClass('hide');
	}

	/**
	*
	*  Show/hide customer address forms
	*
	*/
	function customerAddressForm() {
		var $newAddressForm = $('#AddressNewForm');

		if ( ! $newAddressForm.length) {
			return;
		}

		// Initialize observers on address selectors, defined in shopify_common.js
		if (Shopify) {
			// eslint-disable-next-line no-new
			new Shopify.CountryProvinceSelector(
				'AddressCountryNew',
				'AddressProvinceNew',
				{
					hideElement: 'AddressProvinceContainerNew'
				}
			);
		}

		// Initialize each edit form's country/province selector
		$('.address-country-option').each(function() {
			var formId = $(this).data('form-id');
			var countrySelector = 'AddressCountry_' + formId;
			var provinceSelector = 'AddressProvince_' + formId;
			var containerSelector = 'AddressProvinceContainer_' + formId;

			// eslint-disable-next-line no-new
			new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
				hideElement: containerSelector
			});
		});

		// Toggle new/edit address forms
		$('.address-new-toggle').on('click', function() {
			$newAddressForm.toggleClass('hide');
		});

		$('.address-edit-toggle').on('click', function() {
			var formId = $(this).data('form-id');
			$('#EditAddress_' + formId).toggleClass('hide');
		});

		$('.address-delete').on('click', function() {
			var $el = $(this);
			var formId = $el.data('form-id');
			var confirmMessage = $el.data('confirm-message');

			// eslint-disable-next-line no-alert
			if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
				Shopify.postLink('/account/addresses/' + formId, {parameters: { _method: 'delete' }});
			}
		});
	}

	/**
	*
	*  Check URL for reset password hash
	*
	*/
	function checkUrlHash() {
		var hash = window.location.hash;

		// Allow deep linking to recover password form
		if (hash === '#recover') {
			toggleRecoverPasswordForm();
		}
	}

	return {
		init: function() {
			initCustomer();
		}
	};

})(jQuery);
window.kkco = window.kkco || {};

kkco.Header = (function($) {

	function initHeader() {
		initMobileNav();
		initDesktopNav();
		initResize();
	}
	
	function initMobileNav() {
		// Setup subnav toggle
		$('.mobile-primary-nav a[data-sub]').each(function() {
			var link = $(this);
		
			link.on('click', function(e) {
				e.preventDefault();
		
				if (typeof link.data('sub') == 'undefined') {
					return false;
				}
		
				var target = '#' + link.data('sub');
				if ($(target).length > 0) {
					$(target).toggleClass('active');
					
					if ($(target).hasClass('active')) {
						$(target).attr('aria-hidden', 'false');
					} else {
						$(target).attr('aria-hidden', 'true');
					}					 	
				}
			});
		});
	
		// Open mobile nav
		$('.mobile-nav-menu').on('click', function() {
			$('body').toggleClass('mobile-nav-open');
			$('.mobile-nav').attr('aria-hidden', 'false');
		
			return false;
		});
		
		// Close mobile nav
		$('.mobile-nav-close').on('click', function() {
			$('body').removeClass('mobile-nav-open');
			$('.mobile-nav').attr('aria-hidden', 'true');
		
			return false;
		});
	}
	
	function initDesktopNav() {	
		// Setup subnav drop-downs
		$('.header-primary-nav a[data-sub]').each(function() {
			var link = $(this);
			var linkTimeout;
			var linkWait = 400;

			link.on('mouseenter', function() {
				if (typeof link.data('sub') == 'undefined') {
					return false;
				}
		
				var target = '#' + link.data('sub');			
				//console.log('Link sub ' + target);
			
				$('.header').removeClass('sub-active');
				$('.header-primary-nav a').removeClass('sub-active');
				$('.sub-nav').removeClass('active');
				if ($(target).length > 0) {
					link.addClass('sub-active');
					$('.header').addClass('sub-active');
					$(target).addClass('active');
					$(target).attr('aria-hidden', 'false');		
				}
						
				$(target).on('mouseenter', function() {
					//console.log('Enter ' + target);
					clearTimeout(linkTimeout);
				});

				$(target).on('mouseleave', function() {
					//console.log('Leave ' + target);

					linkTimeout = setTimeout(function() {
						link.removeClass('sub-active');
						$('.header').removeClass('sub-active');
						$(target).removeClass('active');
						$(target).attr('aria-hidden', 'true');				
						$(target).off('mouseenter mouseleave');
						//console.log('Timeout ' + target);
					}, linkWait);
				});
			
				clearTimeout(linkTimeout);
			});

			link.on('mouseleave', function() {
				if (typeof link.data('sub') == 'undefined') {
					return false;
				}
	
				var target = '#' + link.data('sub');
				//console.log('Leave link');
			
				linkTimeout = setTimeout(function() {
					link.removeClass('sub-active');
					$('.header').removeClass('sub-active');
					$(target).removeClass('active');
					$(target).attr('aria-hidden', 'true');			
					$(target).off('mouseenter mouseleave');
					//console.log('Timeout ' + target);
				}, linkWait);
			});
		});
		
		// Fix ARIA attributes for collection, product pages since Shop subnav is shown
		if ($('body').hasClass('template-collection') || $('body').hasClass('template-product')) {			
			var shopSubnav = $('#shop');
			var shopSubnavLink = $('a[data-sub="shop"]');
			
			if (shopSubnav.length > 0) {
				shopSubnav.attr('aria-hidden', 'false');	
			}
			
			if (shopSubnavLink.length > 0) {
				shopSubnavLink.off('mouseenter mouseleave');
			}
		}
	
		// Setup Headroom.js 
		var headerHeight = $('.header').outerHeight();
		$('.header').headroom({
			onTop: function() {		
				if (headerPaddingCheck()) {
					$('main').css('padding-top', 0);
				}
			},
			onNotTop: function() {	
				if (headerPaddingCheck()) {
					$('main').css('padding-top', headerHeight + 'px');
				}
			}
		});
		
		// Check page to determine if main needs padding on scroll
		function headerPaddingCheck() {
			var addPadding = true;
			
			// Home page
			if ($('body').hasClass('template-index')) {
				//console.log('Home Page');
				addPadding = false;
			}
			
			// Catalog Page /collections/all
			if ($('body').hasClass('template-collection') && $('body').hasClass('handle-all')) {
				//console.log('Catalog Page');
				addPadding = false;
			}
			
			
			// Override addPadding for mobile/tablet
			if ( ! window.matchMedia('(min-width: 992px)').matches) {
				//console.log('Min-width 992px');
				addPadding = true;
			}
			
			//console.log('Returning ' + addPadding);
			
			return addPadding;
		}
	}
	
	function initResize() {	
		// Window resize function to toggle aria-hidden true/false
		// for header-nav and header-mobile-nav on target breakpoint
		$(window).on('resize', jQuery.debounce(100, false, function() {			
			if (window.matchMedia('(min-width: 992px)').matches) {
				$('.header-nav').attr('aria-hidden', 'false');
				$('.header-mobile-nav').attr('aria-hidden', 'true');
				return false;
			}
			
			$('.header-nav').attr('aria-hidden', 'true');
			$('.header-mobile-nav').attr('aria-hidden', 'false');
		}));
		
		$(window).trigger('resize');
	}

	return {
		init: function() {
			initHeader();
		}
	};

})(jQuery);
	
window.kkco = window.kkco || {};

kkco.Help = (function($) {

	function initHelp() {
		initSidebar();
	}
	
	function initSidebar() {
		$('.help-sidebar a').on('click', function(e) {
			e.preventDefault();			
			
			var target = $(this).attr('href');
			if ($(target).length > 0) {
				var targetOffset = $(target).offset().top;			
				
				$('html,body').scrollTop(targetOffset - 80);
			}
		});
	}

	return {
		init: function() {
			initHelp();
		}
	};

})(jQuery);
	
window.kkco = window.kkco || {};

kkco.Newsletter = (function($) {

	function initNewsletter() {
		initForm();
		initPopUpScroll();
		initResize();
	}

	function initForm() {
		$('.footer-newsletter-open').on('click', function(e) {
			e.preventDefault();

			showPopUp();
		});

		$('.footer-newsletter-close').on('click', function(e) {
			e.preventDefault();

			hidePopUp();
			setPopUpCookie();
		});

        $('.footer-newsletter').on('keydown', function(e) {
            var ESC_BUTTON = 27;

            if (e.which == ESC_BUTTON) {
                e.preventDefault();

                hidePopUp();
            }
        });

		$('.newsletter-popup-form').on('submit', function(e) {
		    e.preventDefault();

		    submitForm();
		});
	}

	function initPopUpScroll() {
		var cookie = Cookies.get('kk-co-newsletter');

		if (typeof cookie === 'undefined') {
			$(window).on('scroll', popUpScrollHandler);
		}
	}

	function popUpScrollHandler() {
		var visible = false;

		// Open newsletter banner after scrolling 60px down page
		if (visible === false && $(window).scrollTop() >= 60) {
			visible = true;

			// Disable scroll event
			$(window).off('scroll', popUpScrollHandler);

			showPopUp();
		}
	}

	function showPopUp() {
	    $('.footer-newsletter').addClass('active');
		toggleAccessibilityFocus(true);

		$(document).on('click', popUpClick);
	}

	function hidePopUp() {
        $('.footer-newsletter').removeClass('active');
        toggleAccessibilityFocus(false);

        $(document).off('click', popUpClick);
	}

    function popUpClick(event) {
	    var targetLink = $(event.target).closest('.footer-newsletter-open');
	    var targetElement = $(event.target).closest('#footer-newsletter');

	    // Close popup if click target wasn't inside link or element
        if (  ! targetLink.length && ! targetElement.length) {
            hidePopUp();
        }
	}

	function setPopUpCookie() {
		Cookies.set('kk-co-newsletter', '1', {expires: 30});
	}

	function setSubscribeCookie() {
		Cookies.set('kk-co-newsletter', '1', {expires: 400});
	}

	function toggleAccessibilityFocus(focus) {
		if ( ! focus) {
			$('.footer-newsletter').attr('aria-hidden', true);
			$('.footer-newsletter').find('input[type=email], button, a')
			    .attr('tabindex', -1)
			    .blur();

			return false;
		}

		$('.footer-newsletter').attr('aria-hidden', false);
		$('.footer-newsletter').find('input[type=email], button, a').attr('tabindex', 0);
		$('.footer-newsletter').find('input[type=email]').focus();
	}

	function initResize() {
		// Window resize function to toggle aria-hidden true/false
		// for footer-newsletter on target breakpoint
		$(window).on('resize', jQuery.debounce(100, false, function() {
			if (window.matchMedia('(min-width: 992px)').matches) {
				toggleAccessibilityFocus(false);
				return false;
			}

			toggleAccessibilityFocus(true);
		}));

		$(window).trigger('resize');
	}

    function submitForm() {
        var button = $('.newsletter-popup-form button')[0];
        var form = $('.newsletter-popup-form')[0];
        var input = $('#newsletter-popup-email')[0];

        button.disabled = true;
        subscribeRequest(form)
            .then((response) => {
                if ('status' in response && response.status === 202) {
                    form.reset();
                    form.classList.add('disabled');
                    input.value = 'Thank you for joining';
                    input.disabled = true;

                    // Hide popup for 400 days if subscribed
                    setSubscribeCookie();
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                button.disabled = false;
            });
    }

    function subscribeRequest(form) {
        const formData = new FormData(form);

        const fetchConfig = {
            data: {
                type: 'subscription',
                attributes: {
                    profile: {
                        data: {
                            type: 'profile',
                            attributes: {
                                email: formData.get('email'),
                            },
                        },
                    },
                },
                relationships: {
                    list: {
                        data: {
                            type: 'list',
                            id: formData.get('g'),
                        },
                    },
                },
            },
        };
        //console.log(JSON.stringify(fetchConfig));

        return fetch(
            form.action + '?company_id=' + formData.get('company_id'),
            {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    Revision: '2026-01-15',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(fetchConfig),
            },
        );
    }

	return {
		init: function() {
			initNewsletter();
		}
	};

})(jQuery);

window.kkco = window.kkco || {};

kkco.Product = (function($) {

	function initProduct() {
		initAccordion();
		initSizeOptions();
		initOptions();
		initNotifications();		
	}
	
	function initAccordion() {
		// Basic accordion
		// @link http://uniondesign.ca/simple-accordion-without-jquery-ui/
		$('.accordion-item-label a').on('click', function() {			
			var activeLabel = $(this).parent();
			activeLabel.toggleClass('active');
			console.log('activeLabel', activeLabel);
			
			var activeLink = $(this);			
			activeLink.attr('aria-selected', 'true')
				.attr('aria-expanded', 'true')
				.attr('tabindex', 0);
			
			var activeTab = activeLabel.next();
			activeTab.attr('aria-hidden', 'false')
				.slideToggle('fast');

			$('.accordion .accordion-item-label').not(function(index, element) {				
				if ( ! $(this).is(activeLabel)) {
					$(this).removeClass('active');
					var inactiveLink = $(this).find('a');
					inactiveLink.attr('aria-selected', 'false')
						.attr('aria-expanded', 'false')
						.attr('tabindex', -1);
				}
			});
			
			$('.accordion .accordion-item-content').not(activeTab)
				.attr('aria-hidden', 'true')
				.slideUp('fast');

			return false;
		});
	}
	
	function initOptions() {
		// Size select
		$(document).on('click', '.option-block a', function() {
			//console.log('click', '.option-block a');
			var $this = $(this);
			var parent = $this.parent().parent();
			var target = parent.data('target');
			var value = String($this.data('value')).replace('/', '\\/');			
			//console.log($this.data('value'), value);

			$(target).val($this.data('value'));
			$(target).find('[value=' + value + ']').prop('selected', true).trigger('change');
			//console.log(target, $(target).val());

			parent.find('.option-block a').removeClass('active');
			$this.addClass('active');

			return false;
		});
	}

	function initSizeOptions() {
		//console.log('initSizeOptions');

		$('.product-option-size .option-blocks').remove();

		var sizeOptions = '<ul class="option-blocks" data-target="{target}">{options}</ul>';
		var sizeOptionBlock = '<li class="option-block"><a href="#" data-value="{value}">{label}</a></li>';
		var sizeOptionBlocks = '';
		var sizeOptionsDisplay = 'normal';
		var sizeSelectId = 'select#' + $('.product-option-size select').attr('id');

		$('.product-option-size option').each(function() {
			if ($(this).val() !== '') {
				//sizeOptions.push({value: $(this).val(), label: $(this).text()});
				var block = sizeOptionBlock;
				block = block.replace('{value}', $(this).val());
				block = block.replace('{label}', $(this).text());
				sizeOptionBlocks += block;
			}

			if ($(this).text().length > 4) {
				sizeOptionsDisplay = 'wide';
			}
		});
		
		//console.log(sizeOptionBlocks);

		if (sizeOptionBlocks.length > 0) {
			sizeOptions = sizeOptions.replace('{target}', sizeSelectId);
			sizeOptions = sizeOptions.replace('{options}', sizeOptionBlocks);

			$('.product-option-size label').after(sizeOptions);
		}
	}
	
	function initNotifications() {			
		$('#ProductSection-product').on('availabilityUpdated', function() {
			//console.log('availabilityUpdated');
		
			// Get product name
			var productName = '';
			productName = $('.product-name').text().trim();
			
			// Get selected options
			var selectedOptions = [];
			var selectedOptionsText = '';
			$('.single-option-selector').each(function() {
				selectedOptions.push($(this).val());
			});
			if (selectedOptions.length > 0) {
				selectedOptionsText = selectedOptions.join(' / ');
			}
			
			// Build and set form message
			var formMessage = "Please notify me when [product] ([options]) becomes available.";			
			formMessage = formMessage.replace('[product]', productName);
			formMessage = formMessage.replace('[options]', selectedOptionsText);
			
			$('[data-restock-notification-message]').val(formMessage);
		
			// Toggle restock notification
			if ($('.product-cart').is(':disabled')) {
				$('.restock-notification-link').show();
				return false;
			}
			
			$('.restock-notification-link, .restock-notification-form').hide();
		});
		$('#ProductSection-product').trigger('availabilityUpdated');
		
		// Toggle form visibility
		$('.restock-notification-link').on('click', function(e) {
			e.preventDefault();
						
			toggleForm();
		});
		
		// Display form on reload
		// ?contact%5Bbody%5D=Please+notify+me+when+Forage+Hoodie+in+Lime+%28Lime+%2F+S%29+becomes+available.&contact%5Bemail%5D=&form_type=contact
		var urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has('form_type') && urlParams.get('form_type') == 'contact') {
			//console.log('Display form on reload');
			toggleForm(true);
		}
		
		// Display form success
		// ?contact_posted=true	
		if (urlParams.has('contact_posted') && urlParams.get('contact_posted') == 'true') {
			//console.log('Display form success');
			toggleForm(true);
		}		
	}
	
	function toggleForm(toggle) {
		toggle = (typeof toggle !== 'undefined') ?  toggle : null;
		//console.log('toggle', toggle);
	
		$('.restock-notification-form').toggle(toggle);
			
		if ($('.restock-notification-form').is(':visible')) {
			$('.restock-notification-link').attr('aria-expanded', true);
			$('.restock-notification-form').attr('aria-hidden', false);
			$('.restock-notification-form').find('form, input[type=email], input[type=submit]').attr('tabindex', 0);
		} else {
			$('.restock-notification-link').attr('aria-expanded', false);
			$('.restock-notification-form').attr('aria-hidden', true);
			$('.restock-notification-form').find('form, input[type=email], input[type=submit]').attr('tabindex', -1);
		}
	}

	return {
		init: function() {
			initProduct();
		}
	};

})(jQuery);
window.kkco = window.kkco || {};

kkco.Video = (function($) {
	
	var hasInteracted = false;
	
	function initVideo() {
		initControls();
		initVisibilityCheck();
		initInteractionCheck();
	}
	
	function initControls() {
		// Mute button
		if ($('.video-feature').length > 0) {
			$('.video-feature').each(function() {
				var video = $(this);
				var videoElement = video.find('video');
				var controls = video.find('.video-volume');
				
				controls.on('click', function() {
					//console.log(videoElement.prop('muted'));
					if (videoElement.prop('muted') == true) {		
						//console.log('Unmute video');
						$(this).removeClass('muted');
						video.data('muted', false);
						toggleAudio(video, true);
					} else {
						//console.log('Mute video');					
						$(this).addClass('muted');
						video.data('muted', true);
						toggleAudio(video, false);
					}
				});
			});
			
			// Spacebar
			$('body').keyup(function(e) {
				if (e.keyCode == 32) {
					if ($('.video-feature').visible(true)) {
						videoElement = $('.video-feature video').get(0);
						if (videoElement.paused == true) {
							videoElement.play();
						} else {
							videoElement.pause();
						}
					}
				}
			});	
		}
	}
	
	function toggleAudio(video, enable) {
		var videoControls = video.find('.video-volume');
		var videoElement = video.find('video');
		var videoMuted = Boolean(video.data('muted'));
		//console.log('videoMuted', videoMuted);
			
		if (enable) {	
			// Only enable audio if video was not manually muted		
			if ( ! videoMuted) {
				var prop = videoElement.prop('muted', false);
				videoElement.stop(true, false).animate({volume: 0.5}, 500);
				videoControls.removeClass('muted');
				videoControls.attr('aria-pressed', false);
			}
		} else {			
			videoElement.stop(true, false).animate({volume: 0}, 500, 'swing', function() {
				videoElement.prop('muted', true);
				videoElement.get(0).volume = 0;
				videoControls.addClass('muted');
				videoControls.attr('aria-pressed', true);
			});
		}
	}
	
	function initVisibilityCheck() {
		// KLUDGE: Detect Chrome to avoid audio issues
		// Both Safari and Firefox block auto-play with audio and stop video playback
		// Safari: Safari > Settings for This Website > Auto-Play > Stop Media with Sound
		// Firefox: Site Information > Permissions > Block websites from automatically playing sound 
		var isChrome = !!window.chrome;

		// Setup scroll event if video-feature element is on page
		if ($('.video-feature[data-audio]').length > 0) {			
			$(window).on('scroll', jQuery.debounce(100, false, function() {			
				// Check if any part of a video-feature element visible and toggle audio
				if ($('.video-feature').visible(true)) {
					if (isChrome && hasInteracted) {
						toggleAudio($('.video-feature'), true);
					}
				} else {
					if (isChrome && hasInteracted) {
						toggleAudio($('.video-feature'), false);
					}
				}
			}));
			
			$(window).trigger('scroll');
		}
	}
	
	// KLUDGE: Detect interaction to avoid Chrome warning
	// Chrome: Unmuting failed and the element was paused instead because 
	// the user didn't interact with the document before.
	function initInteractionCheck() {
		if ($('.video-feature[data-audio]').length > 0) {
			window.addEventListener('touchstart', onFirstTouch, false);	
				
			window.addEventListener('mousemove', onFirstMouse, false);
		}
	}
	
	function onFirstTouch() {
		hasInteracted = true;
		//console.log('Touch', hasInteracted);
			
		removeInteractionCheck();
	}
	
	function onFirstMouse() {
		hasInteracted = true;
		//console.log('Mouse', hasInteracted);
			
		removeInteractionCheck();
	}
	
	function removeInteractionCheck() {
		window.removeEventListener('touchstart', onFirstTouch, false);
		
		window.removeEventListener('mousemove', onFirstMouse, false);
	}

	return {
		init: function() {
			initVideo();
		}
	};

})(jQuery);
window.kkco = window.kkco || {};
window.slate = window.slate || {};
window.theme = window.theme || {};

jQuery(document).ready(function($) {
	// Init Kk Co Studio modules
	// See /scripts/modules
	var modules = [
		'Customer',
		'Header',
		'Help',
		'Newsletter',
		'Product',
		'Video'
	];
	
	for (var index in modules) {
		//console.log('kkco.' + modules[index] + ' init');
				
		kkco[modules[index]].init();
	}
	
	// Init Shopify modules 
	// See /scripts/shopify
	var sections = new theme.Sections();
	sections.register('product', theme.Product);
	
	// Remove preload class to enable transitions
	// https://css-tricks.com/transitions-only-after-page-load/
	$('body').removeClass('preload');
	
	// Init Ajaxinate
	var endlessScroll = new Ajaxinate({
		container: '#AjaxinateLoop',
		pagination: '#AjaxinatePagination',
		callback: function() {
			//console.log('Ajaxinate loading new page');
		}
	});
	//console.log(endlessScroll);
});
